import { Component, Inject, OnInit } from '@angular/core';
import { CommonService } from 'src/app/shared/services/common.service';
import { TrnxCommonTs } from './../../shared/common/trnxCommonTs';
import { Actionbutton } from './../../shared/common/Actionbutton';
import { LocalStorageSettingsService } from './../../shared/services/local-storage-settings.service';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ReportlinksserviceService } from './../reportlinks/reportlinksservice.service';
import { ErrorMessages } from './../../shared/common/errormessages';
import { constants } from './../../shared/common/contants';
import { MatSnackBar } from '@angular/material/snack-bar';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { ReportingServiceService } from './../../shared/services/reporting-service.service';
import { validationmethod } from './../../shared/Validations/Validationmethods';
import { UntypedFormGroup, UntypedFormControl, Validators, UntypedFormBuilder } from '@angular/forms';
import { VaultObjectgroupService } from '../vaultobject-popup-screen/vault-objectgroup.service';
import { DropdownCellRendererComponent } from '../vaultobject-popup-screen-extractiongrp/dropdowncompo';
import { InputCellRendererComponent } from '../vaultobject-popup-screen-extractiongrp/inputboxcellrendered';
import { Console } from 'console';
export interface VaultObjectData {
  data: any;
}

@Component({
    selector: 'app-vaultobjectgroupchildextraction',
    templateUrl: './vaultobjectgroupchildextraction.component.html',
    styleUrls: ['./vaultobjectgroupchildextraction.component.scss'],
    standalone: false
})
export class VaultobjectgroupchildextractionComponent implements OnInit {

  validations_form: UntypedFormGroup;
  ObjectGrid: any;
  paramstemp;
  ObjectsData: any = [];
  vaultGroup: any = []
  columnDefsForObjects;
  reportCreationData = { "description": "", "groupname": "", objectid: [], "groupType": "Extraction Group", "groupExtractionType": "", "setsSplitRequired": "", "sourceDNS": [],"csvtojsonpartitionsubstringlength":"","csvtojsonpartitionsubstringstartposition":"","csvtojsoncsvpartitionname":"","extractionsource":"","fieldsfromobjectmetadata":"","csvextractionsource":"","splitby":"" }
  defaultColDef;
  rowSelection;
  allFields: any[];
  selectedFieldsData: any[];
  gridApiForTablesFields;
  selectedObject;
  selectObjectId: any;
  columnDefsForReportingConfiguration: any[];
  tableFields: any[];
  fieldsData: any[];
  tablefields: any;
  gridAPI;
  validation_messages
  // columnDefsForTablesFields;
  ngModelObjectTemporary;
  fieldsDataToRemove: any;
  selectedFieldsDataToPush: any = [];
  temp: any = [];
  selectedTableFields: any;
  gridApi;
  rowbindingdata;
  gridColumnApi;
  getdata: any = []
  backgroundColorScreen = "";
  buttonColor = "";
  columnDefsForSelectedFields: any;
  rowSelectionForTablesFields;
  components: any;
  isCheckboxSelected: boolean = false;
  // columnDefs;
  retrieveObject: any = [];
  setObject: any = [];
  tableName = "";
  listObjectDropDown: any = [];
  ngModelObject = [];
  updateButton = false;
  allocateButtonsBoolean = false;
  backgroundColorButton = "";

  recordsStart = 0;
  retrieveNgModelCreation: any = [];
  gridColumnAPI;
  selectedObjects: any = [];
  buttonName: any = "Save";
  buttonNameClose;
  hide = false;
  eyeIcon = true;
  nextButton = true;
  parentUpdate;
  formValidCheckbox: UntypedFormGroup;
  formValid: UntypedFormGroup;
  screenTypeTOrM: any;
  nextSaveTOrM = "";
  allocateButtons1Boolean = false;
  closeIconButtonBoolean = false;
  closeIconButton1Boolean = false;
  bootstrapColumn: any;
  groupName: any;
  objectData: any = [];
  updateData: any;
  objectGroupData: any = [];
  allData: any = [];
  value;
  checkUpdateparentValueCalling = false;

  listOfSourceDNS: any = [];
  addRecord = false;


  constructor(private dialogref: MatDialogRef<VaultobjectgroupchildextractionComponent>, private validation: validationmethod, private service: ReportingServiceService, private spinner: NgxUiLoaderService, private snackbar: MatSnackBar, private constants: constants, private msg: ErrorMessages, private fb: UntypedFormBuilder, private linkservice: ReportlinksserviceService, private localStorageSettings: LocalStorageSettingsService, private vaultObjectService: VaultObjectgroupService, private trnxCommonTs: TrnxCommonTs, private commonService: CommonService, @Inject(MAT_DIALOG_DATA) public data: VaultObjectData,) {
    this.validation_messages = this.msg.reportConfiguration;
    //cell rendering in ag-grid
    this.components = {
      buttonRenderer: Actionbutton,
      dropdown: DropdownCellRendererComponent,
      inputbox: InputCellRendererComponent

    }
  }

  formValidation() {
    this.validations_form = new UntypedFormGroup({
      groupname: new UntypedFormControl('', [Validators.required,this.validation.specialCharacterValidator]),
      description: new UntypedFormControl('', [Validators.required,this.validation.specialCharacterValidator]),

      sourceDNS: new UntypedFormControl('', [Validators.required]),
      groupExtractionType:new UntypedFormControl('', [Validators.required]),
      setsSplitRequired:new UntypedFormControl('', [Validators.required]),
      csvtojsonpartitionsubstringlength:new UntypedFormControl('', [Validators.required]),
      csvtojsonpartitionsubstringstartposition:new UntypedFormControl('', [Validators.required]),
      csvtojsoncsvpartitionname:new UntypedFormControl('', [Validators.required,this.validation.specialCharacterValidator]),
      extractionsource:new UntypedFormControl('', [Validators.required]),
      fieldsfromobjectmetadata:new UntypedFormControl('', [Validators.required]),
      csvextractionsource:new UntypedFormControl('', [Validators.required]),
      splitby:new UntypedFormControl('', [Validators.required]),
    });
  }



  ngOnInit() {
    this.retrieveSourceDNS();
    console.log("-=-=-=-=-=-=", this.data)
    this.updateData = this.data;
    console.log(this.updateData.data)
    console.log(this.updateData.data.rowData.description)
    this.reportCreationData.description = this.updateData.data.rowData.description;
    this.reportCreationData.groupname = this.updateData.data.rowData.objectGroupName;
    this.reportCreationData.groupExtractionType = this.updateData.data.rowData.groupExtractionType;
    this.reportCreationData.setsSplitRequired = this.updateData.data.rowData.setsSplitRequired;
    this.reportCreationData.csvtojsoncsvpartitionname=this.updateData.data.rowData.csvtojsoncsvpartitionname;
    this.reportCreationData.csvtojsonpartitionsubstringstartposition=this.updateData.data.rowData.csvtojsonpartitionsubstringstartposition;
    this.reportCreationData.csvtojsonpartitionsubstringlength=this.updateData.data.rowData.csvtojsonpartitionsubstringlength;
    this.reportCreationData.extractionsource=this.updateData.data.rowData.extractionsource;
    this.reportCreationData.fieldsfromobjectmetadata=this.updateData.data.rowData.fieldsfromobjectmetadata;
    this.reportCreationData.csvextractionsource=this.updateData.data.rowData.csvextractionsource;
    this.reportCreationData.splitby=this.updateData.data.rowData.splitby
    console.log(this.updateData.data.rowData.csvextractionsource);
    console.log(this.updateData.data.rowData.objectGroupId);
    this.vaultObjectService.retrieveobjects(this.updateData.data.rowData.objectGroupId).subscribe(result => {
      console.log(result)
      this.allData = result;
      console.log(this.allData);
      for (let i = 0; i < this.allData.length; i++) {
        console.log("inside loop    " + this.allData[i])
        let obj = {
          filterCriteriaForExtraction: this.allData[i].filtercriteriaforextraction,
          isParent: this.allData[i].isparent,
          objectid: this.allData[i].objectId,
          vqlCriteria: this.allData[i].vqlcriteria,
          vqlCriteriaForIncremental: this.allData[i].vqlcriteriaforincremental,
          objectUniqueId: this.allData[i].id,
          setSplitObject: this.allData[i].setSplitObject,
          fileName: this.allData[i].fileName,
          globalExtractionObject: this.allData[i].globalExtractionObject,
          globalExtractionObjectField: this.allData[i].globalExtractionObjectField,
          extractionObject: this.allData[i].extractionObject,
          extractionObjectField: this.allData[i].extractionObjectField,
          level:this.allData[i].level,
          filename:this.allData[i].filename,
    
   parentobjectfilename : this.allData[i].parentobjectfilename,
    parentobjectkeycolumn : this.allData[i].parentobjectkeycolumn,
    requiredInDataLake:this.allData[i].requiredInDataLake,
    refreshInIncremental:this.allData[i].refreshInIncremental
        }
        this.reportCreationData.objectid.push(obj)
        // this.selectedObjects.push(obj);
      }
      console.log(this.reportCreationData)
      this.onGridReadyForSelectedTableFields(this.selectedTableFields, this.allData);
    });


    this.validations_form = this.fb.group({
      groupname: '',
      description: '',
      sourceDNS : [],
      groupExtractionType: '',
      setsSplitRequired: '',
      csvtojsoncsvpartitionname: "",
      csvtojsonpartitionsubstringstartposition: "",
      csvtojsonpartitionsubstringlength:"",
      extractionsource:"",
      fieldsfromobjectmetadata:"",
      csvextractionsource:"",
      splitby:"",
    });
    this.formValidCheckbox = this.fb.group({
      isCheckboxSelected: ''
    });


    // this.lookupVaultGroup();

    this.columnDefsForObjects = [
      {
        headerName: "Objects",
        headerTooltip: "Objects",
        tooltipValueGetter: params => "Objects : " + params.value,
        field: "objectlabel",
        filter: "agTextColumnFilter",
        width: 250,
        headerClass: 'headerClassName',
        headerCheckboxSelectionFilteredOnly: true,
        checkboxSelection: true,
        cellStyle: { " padding-left": "5px" }
      }
    ];
    this.columnDefsForSelectedFields = [
      {
        headerName: "Selected Objects",
        headerTooltip: "Selected  Objects",
        tooltipValueGetter: params => "Selected  Objects : " + params.value,
        field: "objectlabel",
        filter: "agTextColumnFilter",
        width: 200,
        headerCheckboxSelectionFilteredOnly: true,
        checkboxSelection: true,
        cellStyle: { " padding-left": "5px" }
      },
      {

        headerName: "File Name",
        headerTooltip: "File Name",
        tooltipValueGetter: params => "File Name" + params.value,
        field: "fileName",
        filter: "agTextColumnFilter",
        width: 200,
        cellRenderer: "inputbox",
        cellRendererParams: {
          edit: this.updateObjectnameValue.bind(this)
        }
      },
      {
        headerName: "IsParent",
        headerTooltip: "IsParent",
        tooltipValueGetter: params => "IsParent : " + params.value,
        field: "isparent",
        filter: "agTextColumnFilter",
        width: 160,
        cellRenderer: "dropdown",
        cellRendererParams: {
          edit: this.updateParentValue.bind(this)

        },

      },
      {
        headerName: "Filter Criteria For Extraction",
        headerTooltip: "Filter Criteria For Extraction",
        tooltipValueGetter: params => "Filter Criteria For Extraction : " + params.value,
        field: "filtercriteriaforextraction",
        filter: "agTextColumnFilter",
        width: 260,
        cellRenderer: "inputbox",
        cellRendererParams: {
          edit: this.setFilterCriteriaForExtrac.bind(this)
        },

      },
      {
        headerName: "Query Criteria",
        headerTooltip: "Query Criteria",
        tooltipValueGetter: params => "Query Criteria : " + params.value,
        field: "vqlcriteria",
        filter: "agTextColumnFilter",
        width: 260,
        cellRenderer: "inputbox",
        cellRendererParams: {
          edit: this.setVqlCriteria.bind(this)
        },
      },
      {

        headerName: "Query Criteria for Incremental Extraction",
        headerTooltip: "Query Criteria for Incremental Extraction",
        tooltipValueGetter: params => "Query Criteria for Incremental Extraction : " + params.value,
        field: "vqlcriteriaforincremental",
        filter: "agTextColumnFilter",
        width: 260,
        cellRenderer: "inputbox",
        cellRendererParams: {
          edit: this.setVqlCriteriaForIncre.bind(this)
        },
      },
      {

        headerName: "Set Split Field Name",
        headerTooltip: "Set Split Field Name",
        tooltipValueGetter: params => "Set Split Field Name" + params.value,
        field: "setSplitObject",
        filter: "agTextColumnFilter",
        width: 200,
        cellRenderer: "inputbox",
        cellRendererParams: {
          edit: this.updateSetSplitObjectValue.bind(this)
        }
      },
      {

        headerName: "Global Extraction Object Reference",
        headerTooltip: "Global Extraction Object Reference",
        tooltipValueGetter: params => "Global Extraction Object Reference" + params.value,
        field: "globalExtractionObject",
        filter: "agTextColumnFilter",
        width: 200,
        cellRenderer: "inputbox",
        cellRendererParams: {
          edit: this.updateGlobalExtractionObjectValue.bind(this)
        }
      },
      {

        headerName: "Global Extraction Object Reference Field",
        headerTooltip: "Global Extraction Object Reference Field",
        tooltipValueGetter: params => "Global Extraction Object Reference Field" + params.value,
        field: "globalExtractionObjectField",
        filter: "agTextColumnFilter",
        width: 200,
        cellRenderer: "inputbox",
        cellRendererParams: {
          edit: this.updateGlobalExtractionObjectFieldValue.bind(this)
        }
      },
      {

        headerName: "Extraction Object Reference",
        headerTooltip: "Extraction Object Reference",
        tooltipValueGetter: params => "Extraction Object Reference" + params.value,
        field: "extractionObject",
        filter: "agTextColumnFilter",
        width: 200,
        cellRenderer: "inputbox",
        cellRendererParams: {
          edit: this.updateExtractionObjectValue.bind(this)
        }
      },
      {

        headerName: "Extraction Object Reference Field",
        headerTooltip: "Extraction Object Reference Field",
        tooltipValueGetter: params => "Extraction Object Reference Field" + params.value,
        field: "extractionObjectField",
        filter: "agTextColumnFilter",
        width: 200,
        cellRenderer: "inputbox",
        cellRendererParams: {
          edit: this.updateExtractionObjectFieldValue.bind(this)
        }
      },
      {

        headerName: "File Name",
        headerTooltip: "File Name",
        tooltipValueGetter: params => "File Name" + params.value,
        field: "filename",
        filter: "agTextColumnFilter",
        width: 200,
        cellRenderer: "inputbox",
        cellRendererParams: {
          edit: this.updateFileNameValue.bind(this)
        }
      },
      {

        headerName: "Level",
        headerTooltip: "Level",
        tooltipValueGetter: params => "Level" + params.value,
        field: "level",
        filter: "agTextColumnFilter",
        width: 200,
        cellRenderer: "inputbox",
        cellRendererParams: {
          edit: this.updateLevelValue.bind(this)
        }
      },
      {

        headerName: "Parent Object File Name",
        headerTooltip: "Parent Object File Name",
        tooltipValueGetter: params => "Parent Object File Name" + params.value,
        field: "parentobjectfilename",
        filter: "agTextColumnFilter",
        width: 200,
        cellRenderer: "inputbox",
        cellRendererParams: {
          edit: this.updateParentObjectFilename.bind(this)
        }
      },
      {

        headerName: "Parent Object Key Column",
        headerTooltip: "Parent Object Key Column",
        tooltipValueGetter: params => "Parent Object Key Column" + params.value,
        field: "parentobjectkeycolumn",
        filter: "agTextColumnFilter",
        width: 200,
        cellRenderer: "inputbox",
        cellRendererParams: {
          edit: this.updateparentobjectkeycolumn.bind(this)
        }
      },
       {
        headerName: "Required In DataLake",
        headerTooltip: "Required In DataLake",
        tooltipValueGetter: params => "Required In DataLake: " + params.value,
        field: "requiredInDataLake",
        filter: "agTextColumnFilter",
        width: 160,
        cellRenderer: "inputbox",
        cellRendererParams: {
          edit: this.updateRequiredInDatalake.bind(this)

        }
      }
,
      
      {
        headerName: "Refresh in Incremental",
        headerTooltip: "Refresh in Incremental",
        tooltipValueGetter: params => "Refresh in Incremental: " + params.value,
        field: "refreshInIncremental",
        filter: "agTextColumnFilter",
        width: 160,
        cellRenderer: "inputbox",
        cellRendererParams: {
          edit: this.updaterefreshInIncremental.bind(this)

        }
      }
    ];

    this.defaultColDef = {
filterParams: {
        maxNumConditions: 2,
        numAlwaysVisibleConditions: 2,
        defaultJoinOperator: 'OR'
      },
      sortable: true,
      resizable: true,
      filter: true
    };

    this.rowSelectionForTablesFields = 'multiple';
    this.rowSelection = this.constants.rowselection;
    this.backgroundColorScreen = this.localStorageSettings.getSettings("ColorD");
    this.buttonColor = this.localStorageSettings.getSettings("ColorA");

    // save and update button toggle
    if (this.buttonName == "Save") {

      this.buttonNameClose = "Save";

    }

    else {

      this.buttonNameClose = "Update";

      this.hide = false;
    }

    if (this.bootstrapColumn == 1) {

      this.allocateButtons1Boolean = true;

      this.closeIconButton1Boolean = true;

    }
    else {

      this.allocateButtonsBoolean = true;

      this.closeIconButtonBoolean = true;

    }

    this.backgroundColorButton = this.localStorageSettings.getSettings("ColorA");

    console.log(this.backgroundColorButton);
    console.log(this.buttonName);

    this.formValidationsCheckbox();

  }

  selectcheckedfield() {
    console.log(this.ObjectGrid.api)
    for (let o = 0; o < this.allData.length; o++) {
      console.log(this.allData[o]);
      this.ObjectGrid.api.forEachNode(node => {
        console.log(node);
        if (node.data.objectlabel === this.allData[o].objectlabel) {

          const filteredTemp = this.temp.filter(item => item.objectId == this.allData[o].objectId);
          if (filteredTemp.length <= 0) {
            node.setSelected(true);
            this.temp.push(this.allData[o])
            console.log(this.allData[o]);
            this.onGridReadyForSelectedTableFields(this.selectedTableFields,this.temp)
          }

        }
      });
    }

    console.log(this.temp);


  }



  onGridReady(params) {
    this.rowbindingdata = params;
    this.gridApi = params.api;
    this.gridColumnApi = params.columnApi;
    this.linkservice.retrievereportlinks().subscribe(response => {
      this.spinner.start();
      console.log(response);
      // checking if response is true or not
      if (response.error == true) {
        this.snackbar.open(response.statusMessage, "OK", {
          duration: 5000,
        });
        this.rowbindingdata.setGridOption('rowData', [])

      } else {

        console.log(response)
        this.getdata = response
        console.log(this.getdata)
        // for(let i=0;i<this.getdata.length;i++){
        //   console.log(this.getdata[i].objectlabel)
        //   console.log(this.updateData.data.rowData.objectlabel)
        //   if(this.getdata[i].objectlabel===this.updateData.data.rowData.objectlabel){
        //     this.rowbindingdata.api.setSelected(true,true);
        //   }
        // }
        this.rowbindingdata.api.setGridOption('rowData', this.getdata)
      }
      this.spinner.stop();
    });
  }

  async onGridReadyForObjects(params) {
    // this.tableFields = [];
    // this.selectedObjects = [];
    console.log(",,,,,,,,,,,,,,,,,,,,," + this.selectedObjects)
    this.ObjectGrid = params;
    this.spinner.start();
    // let tableName = "objectmetadata";
    // let response = await this.commonService.retrieveRecordService(tableName);
    //this.ObjectGrid.api.setGridOption('rowData', response);
    // if (tableName === undefined) {
    //   this.ObjectGrid.api.setGridOption('rowData', []);
    // } else {
    //   this.tablefields = response;
    //   console.log(this.tablefields)
      this.gridApiForTablesFields = params;
      this.ObjectGrid.api.setGridOption('rowData', this.tablefields);
      //this.selectedObjects.api.setGridOption('rowData', []);
    // }
    //this.gridApiForTablesFields.setGridOption('rowData', response);

    //this.gridApiForTablesFields = params.api;
    this.spinner.stop();

  }


  onRowSelected(event) {
    this.temp=this.selectedObjects;
    console.log(this.temp)
    console.log(this.fieldsData)
    this.fieldsData = this.ObjectGrid.api.getSelectedRows();
    console.log(this.selectedObjects)
    let newSelectedObjects = [];

    for (let a = 0; a < this.fieldsData.length; a++) {
      console.log(this.fieldsData[a]);
      const checkIfEleAlreadyExist = this.temp.filter(item => item.id == this.fieldsData[a].id);
      if (checkIfEleAlreadyExist.length > 0) {
        newSelectedObjects.push(checkIfEleAlreadyExist[0]);
      } else {
        const newObject = {
          ...this.fieldsData[a],
          isparent: "No",
          filtercriteriaforextraction: "",

        };
        console.log(newObject)
        newSelectedObjects.push(newObject);

      }

    }



    this.selectedObjects = newSelectedObjects;



    console.log(this.selectedObjects);
  }

  onGridReadyForSelectedTableFields(params, data) {
    this.selectedTableFields = params
    this.selectedFieldsDataToPush = data;
     console.log(this.selectedTableFields)
     console.log(data);
    this.selectedObjects = data;
    for (let a = 0; a < this.selectedObjects.length; a++) {
      if (this.selectedObjects[a].objectId) {
        this.selectedObjects[a]["id"] = this.selectedObjects[a].objectId;
      }
    }
    console.log(data);
    this.checkUpdateparentValueCalling = false;
    for (let a = 0; a < data.length; a++) {
      console.log("==============================")
      this.checkUpdateparentValueCalling = false;
      this.updateParentValue(data[a].isparent, data[a].id)
    }
    this.selectedTableFields.api.setGridOption('rowData', data);

  }

  //forward Icon Function decleation
  pushDataToSelectedFieldsGrid() {
    this.fieldsDataToRemove = [];
    let uniq = {}
    console.log(this.selectedObjects);
    console.log(this.reportCreationData);
    
    for (let i = 0; i < this.selectedObjects.length; i++) {

      if (!this.reportCreationData.objectid.some(item => item.objectid === this.selectedObjects[i].objectId)) {
        let obje = {
          objectid: this.selectedObjects[i].id,
          isParent: this.selectedObjects[i].isParent,
          filterCriteriaForExtraction: this.selectedObjects[i].filtercriteriaforextraction,
          vqlCriteria: this.selectedObjects[i].vqlcriteria,
          vqlCriteriaForIncremental: this.selectedObjects[i].vqlcriteriaforincremental,
          objectUniqueId: null,
          setSplitObject: this.selectedObjects[i].setSplitObject,
          fileName: this.selectedObjects[i].objectname,
          globalExtractionObject: this.selectedObjects[i].globalExtractionObject,
          globalExtractionObjectField: this.selectedObjects[i].globalExtractionObjectField,
          extractionObject: this.selectedObjects[i].extractionObject,
          extractionObjectField: this.selectedObjects[i].extractionObjectField,
          sourceDnsId: this.selectedObjects[i].tenantid,
          refreshInIncremental:this.selectedObjects[i].refreshInIncremental,
        requiredInDataLake:this.selectedObjects[i].requiredInDataLake
        }
        this.selectedObjects[i].fileName = this.selectedObjects[i].objectname;
        this.reportCreationData.objectid.push(obje)
        // this.reportCreationData.objectid.push(this.selectedObjects[i].id)
      }
    }
    this.selectedObjects = this.selectedObjects.map(obj => ({ ...obj, objectId: obj.id }));
    //this.selectedObjects= this.reportCreationData;
    console.log(this.reportCreationData)
    console.log(this.selectedFieldsDataToPush)
    //duplicates data not allowed
    this.temp = this.selectedObjects.filter(obj => !uniq[obj.objectlabel] && (uniq[obj.objectlabel] = true));
    console.log(this.temp)
    this.onGridReadyForSelectedTableFields(this.selectedTableFields, this.temp)
    //this.gridApiForSelectedTablesFields.setGridOption('rowData', this.temp);
  }

  //double forward Icon Function decleation
  pushDataToSelectedFieldsGridComplete() {
    this.fieldsDataToRemove = [];
    let uniq = {}
    console.log(this.selectedObjects)
    console.log(this.tablefields);
    console.log(this.selectedTableFields)
    console.log(this.temp)
    let newSelectedObjects = [];
      // console.log(this.tableFields.length)
    this.spinner.start();
    for (let field of this.tablefields) {

      if (!this.reportCreationData.objectid.some(item => item.objectid === field.objectId)) {
        let obje = {
          objectid: field.id,
          isParent: field.isParent,
          filterCriteriaForExtraction: field.filtercriteriaforextraction,
          vqlCriteria: field.vqlcriteria,
          vqlCriteriaForIncremental: field.vqlcriteriaforincremental,
          objectUniqueId: null,
          setSplitObject: field.setSplitObject,
          fileName: field.fileName,
          globalExtractionObject: field.globalExtractionObject,
          globalExtractionObjectField: field.globalExtractionObjectField,
          extractionObject: field.extractionObject,
          extractionObjectField: field.extractionObjectField,
          refreshInIncremental:field.refreshInIncremental,
        requiredInDataLake:field.requiredInDataLake
        }

        this.reportCreationData.objectid.push(obje)

        // this.reportCreationData.objectid.push(this.selectedObjects[i].id)
      }

    }
    this.spinner.stop(); 
    console.log(this.reportCreationData);

    for (let field of this.tablefields) {
    //  console.log(field);
      const checkIfEleAlreadyExist = this.temp.filter(item => item.id == field.id);
      if (checkIfEleAlreadyExist.length > 0) {
        newSelectedObjects.push(checkIfEleAlreadyExist[0]);
      } else {
        const newObject = {
          ...field,
          isparent: "No",
          filtercriteriaforextraction: "",

        };
      //  console.log(newObject)
        newSelectedObjects.push(newObject);

      }

    }


     console.log(newSelectedObjects)
    this.temp = newSelectedObjects;
    this.selectedObjects = newSelectedObjects;

    // //duplicates data not allowed
    this.temp = this.temp.filter(obj => !uniq[obj.objectlabel] && (uniq[obj.objectlabel] = true));
    console.log(this.temp)
    this.onGridReadyForSelectedTableFields(this.selectedTableFields, this.temp)
    //this.pushDataToSelectedFieldsGrid();
    this.ObjectGrid.api.forEachNode(node => {

      node.setSelected(true)

    })

  }

  //double backward Icon Function decleation
  popDataToSelectedFieldsGridComplete() {
    this.selectedObjects.length = []
    this.temp.length = []
    this.temp = []
    this.reportCreationData.objectid = []
    this.onGridReadyForSelectedTableFields(this.selectedTableFields, [])
    // this.gridApiForSelectedTablesFields.setGridOption('rowData', []);
    this.ObjectGrid.api.forEachNode(node => {

      node.setSelected(false)

    })
  }

  //backward Icon Function decleation
  popDataToSelectedFieldsGrid() {
    console.log(this.temp)
    let objectIds = this.reportCreationData.objectid
    console.log(objectIds)
    console.log(this.temp)
    console.log(this.fieldsDataToRemove)

    //this.temp = this.temp.filter(item => !this.fieldsDataToRemove.includes(item.objectId));
    this.temp = this.temp.filter(item => !this.fieldsDataToRemove.some(removeItem => removeItem.objectId === item.objectId));


    console.log(this.temp)
    this.onGridReadyForSelectedTableFields(this.selectedTableFields, this.temp)
    //this.gridApiForSelectedTablesFields.setGridOption('rowData', this.temp);
    // this.selectedTableFields = this.temp.filter(item => !this.fieldsDataToRemove.includes(item));
    for (let o = 0; o < this.fieldsDataToRemove.length; o++) {
      this.ObjectGrid.api.forEachNode(node => {
        if (node.data.objectlabel === this.fieldsDataToRemove[o].objectlabel) {
          node.setSelected(false)
        }
      })
    }
    const objectIdToRemove = this.fieldsDataToRemove.map(obj => obj.objectId);
    console.log(objectIdToRemove)
    console.log(this.reportCreationData)
    this.reportCreationData.objectid = objectIds.filter(num => !objectIdToRemove.includes(num.objectid));
    console.log(this.reportCreationData.objectid)
    console.log(this.reportCreationData)
  }

  onRowSelectedToRemove(ev) {
    console.log(ev);
    console.log(this.selectedTableFields.api)
    this.fieldsDataToRemove = this.selectedTableFields.api.getSelectedRows();
    console.log(this.fieldsDataToRemove);
  }

  save() {

    console.log(this.reportCreationData);
const levelMap = new Map<number, string>(); // Map<level, tenantId>

for (const obj of this.selectedObjects) {
  const tenantId = obj.sourcednsid;
  const levelValue = obj.level;
  const sourceType = obj.source;

  //@author:Geetha B, jraap-7307: Skip validation for stage objects in object group as they are not part of extraction(those are created during transformation)
  if (sourceType?.toLowerCase()  === "stage") continue; // Skip validation for stage objects in object group
  // Skip empty levels
  if (levelValue === null || levelValue === undefined || levelValue === '') continue;
  if(levelValue===0 || levelValue ==='0')
{
  alert("Level should be 1 or greater. Level 0 is not allowed.");

}
  // Validate numeric
  const levelNum = Number(levelValue);
  if (isNaN(levelNum)) {
alert("Level value should be a valid number");
    return;
  }

  // Check if same level exists for a different tenant
  if (levelMap.has(levelNum) && levelMap.get(levelNum) !== tenantId) {
   alert(
     `Level value '${levelValue}' must be unique across different sources`
    );
    return;
  }



   const level = Number(obj.level);
  const parentFile = obj.parentobjectfilename?.trim() || "";
  const parentKey  = obj.parentobjectkeycolumn?.trim() || "";
  if (level === 1 && (parentFile !== "" || parentKey !== "")) {
    //  Condition 1: Level 1 should NOT have parent fields
    alert("For level 1, parentobjectfilename and parentobjectkeycolumn are not required.");
    return;

  } else if ((parentFile !== "" && parentKey === "") || (parentKey !== "" && parentFile === "")) {

    // Condition 2: For other levels, both parent fields must be filled together
    alert(`Both Parent Object Filename and Parent Object Key Column are required together for ${obj.objectlabel}`);
    return;
  }

  // Store mapping of level → tenantId
  levelMap.set(levelNum, tenantId);
}

// const invalidObjects = this.selectedObjects.filter(obj => {
//   const isLevelOne = Number(obj.level) === 1;
//   const hasParentFileName = obj.parentobjectfilename && obj.parentobjectfilename.trim() !== "";
//   const hasParentKeyColumn = obj.parentobjectkeycolumn && obj.parentobjectkeycolumn.trim() !== "";

//   // if level 1 and any of these fields has a value -> invalid
//   return isLevelOne && (hasParentFileName || hasParentKeyColumn);
// });

// if (invalidObjects.length > 0) {
//   alert(
//     "For level 1, parentobjectfilename and parentobjectkeycolumn are not required."
//   );
//   return;
// }
    for (let a = 0; a < this.selectedObjects.length; a++) {

      const sourceType = this.selectedObjects[a].source;

      if (sourceType?.toLowerCase()  === "stage") continue;

      if (this.selectedObjects[a].filtercriteriaforextraction === "" || this.selectedObjects[a].filtercriteriaforextraction === null) {
        alert(`Filter criteria for extraction cannot be empty for ${this.selectedObjects[a].objectlabel}`)
        return;
      }
      if (this.selectedObjects[a].vqlcriteria === "" || this.selectedObjects[a].vqlcriteria === null) {
        alert(`Query Criteria cannot be empty for ${this.selectedObjects[a].objectlabel}`)
        return;
      }
      if (this.selectedObjects[a].vqlcriteriaforincremental === "" || this.selectedObjects[a].vqlcriteriaforincremental == null ) {
        alert(`Query Criteria For Incremental Extraction cannot be empty for ${this.selectedObjects[a].objectlabel}`)
        return;
      }
       if(this.selectedObjects[a].isParent ==="Yes" ){
        if (Number(this.selectedObjects[a].level) !== 1) {
    alert("Level should be 1 for parent object.");
    return;
  }
       
      }
      const ril = this.selectedObjects[a].refreshInIncremental;
    if (ril !== null && ril !== undefined && String(ril).trim() !== '') {
      const val = String(ril).trim();
      if (val !== 'Yes' && val !== 'No') {
        alert("Value should be Yes/No in Refresh in Incremental field.");
        return;
      }
    }

    const rid = this.selectedObjects[a].requiredInDataLake;
    if (rid !== null && rid !== undefined && String(rid).trim() !== '') {
      const valRid = String(rid).trim();
      if (valRid !== 'Yes' && valRid !== 'No') {
      alert("Value should be Yes/No in Required In DataLake field.");
      return;
      }
    }
      const obj = this.selectedObjects[a];

// const parentFile = obj.parentobjectfilename;
// const parentKey  = obj.parentobjectkeycolumn;

// // Trim values safely (handle null/undefined)
// const parentFileVal = parentFile ? parentFile.trim() : "";
// const parentKeyVal  = parentKey  ? parentKey.trim()  : "";

// // Check: if one is filled but the other is empty → show alert
// if ((parentFileVal !== "" && parentKeyVal === "") || 
//     (parentKeyVal !== "" && parentFileVal === "")) {
    
//     alert(`Both Parent Object Filename and Parent Object Key Column are required together for ${obj.objectlabel}`);
//     return;
// }
    }

    this.spinner.start();
    this.vaultObjectService.updateObjects(this.updateData.data.rowData.objectGroupId, this.reportCreationData).subscribe(response => {
      // this.spinner.start();
      console.log(response)
      // checking if response is true or not
      if (response.error == true) {
        this.spinner.stop();
        this.snackbar.open(response.statusMessage, "OK", {
          duration: 5000,
        });
      } else {
        this.snackbar.open(response.statusMessage, "OK", {
          duration: 5000,
        });
        this.spinner.stop();
        this.cancel();
        window.location.reload();
      }


      this.spinner.stop();

    });
    // this.cancel();

  }

  formValidationsCheckbox() {

    // form validations
    this.formValidCheckbox = new UntypedFormGroup({
      isCheckboxSelected: new UntypedFormControl("")
    });

  }



  close() {
    console.log(this.isCheckboxSelected);
    console.log(typeof this.isCheckboxSelected);
    //It will execute if checkbox is not selected.
    if (this.isCheckboxSelected == false) {

      //It will reset checkbox form.
      this.validations_form.reset();
      this.formValidCheckbox.reset();

      //It will call checkbox formValidationCheckbox method.
      this.formValidationsCheckbox();

      // this.reportCreationData = [];

      this.dialogref.close();

    }
  }
  cancel() {
    // this.formValidCheckbox.reset();
    // this.formValidationsCheckbox();
    this.isCheckboxSelected = false;
    this.reportCreationData = {
      description: "",
      groupname: "",
      objectid: [],
      groupType: "",
      groupExtractionType: "",
      setsSplitRequired: "",
      sourceDNS : [],
      csvtojsonpartitionsubstringlength:"",
      csvtojsonpartitionsubstringstartposition:"",
      csvtojsoncsvpartitionname:"",
      extractionsource:"",
      fieldsfromobjectmetadata:"",
      csvextractionsource:"",
      splitby:""
    }
    this.dialogref.close();

    this.close();
    //  window.location.reload();
  }

  onSelectionChange() {
    console.log("========================" + this.reportCreationData.groupType)
    console.log("========================" + this.reportCreationData.setsSplitRequired)
    console.log(";;;;;;;;;;;;;;;;;;;;;;;" + this.reportCreationData.groupExtractionType)
    console.log("========================" + this.reportCreationData.csvextractionsource)
  }
  
  updateParentValue(value, id) {
    console.log(value,id);
    console.log(this.selectedObjects)

    if (value == "Yes") {
      let filteredObj = this.selectedObjects.filter(obj => obj.isParent == "Yes");
      // let filteredObjReport = this.reportCreationData.objectid.filter(obj => obj.isParent == "Yes");
      if (filteredObj.length >= 1) {
        console.log(this.checkUpdateparentValueCalling)
        if (this.checkUpdateparentValueCalling) {
          alert("Multiple parent objects cannot be selected in a group")

          return "No";
        }


      }
    } this.checkUpdateparentValueCalling = true;



    for (let i = 0; i < this.selectedObjects.length; i++) {
      if (this.selectedObjects[i].id == id) {
        this.selectedObjects[i].isParent = value
        break;
      }
    }
    for (let i = 0; i < this.reportCreationData.objectid.length; i++) {
      if (this.reportCreationData.objectid[i].objectid == id) {
        this.reportCreationData.objectid[i].isParent = value
        break;
      }
    }
    console.log("selected object from update parent value", this.selectedObjects)
  }

  setFilterCriteriaForExtrac(value, id) {
    console.log(value, id, "====================")
    for (let i = 0; i < this.selectedObjects.length; i++) {
      if (this.selectedObjects[i].id == id) {
        this.selectedObjects[i].filtercriteriaforextraction = value
        break;
      }
    } console.log("selected object from setFilterCriteriaForExtrac", this.selectedObjects)

    for (let i = 0; i < this.reportCreationData.objectid.length; i++) {
      if (this.reportCreationData.objectid[i].objectid == id) {
        this.reportCreationData.objectid[i].filterCriteriaForExtraction = value
        break;
      }
    }

  }
  setVqlCriteria(value, id) {
    console.log(value, id, "====================")
    for (let i = 0; i < this.selectedObjects.length; i++) {
      if (this.selectedObjects[i].id == id) {
        this.selectedObjects[i].vqlcriteria = value
        break;
      }
    }
    for (let i = 0; i < this.reportCreationData.objectid.length; i++) {
      if (this.reportCreationData.objectid[i].objectid == id) {
        this.reportCreationData.objectid[i].vqlCriteria = value
        break;
      }
    }
  }

  setVqlCriteriaForIncre(value, id) {
    console.log(value, id, "====================")
    for (let i = 0; i < this.selectedObjects.length; i++) {
      if (this.selectedObjects[i].id == id) {
        this.selectedObjects[i].vqlcriteriaforincremental = value
        break;
      }
    } console.log("selected object from setVqlCriteriaIncre", this.selectedObjects)

    for (let i = 0; i < this.reportCreationData.objectid.length; i++) {
      if (this.reportCreationData.objectid[i].objectid == id) {
        this.reportCreationData.objectid[i].vqlCriteriaForIncremental = value
        break;
      }
    }
  }

  retrieveSourceDNS(){
    //let userId = this.localStorageSettings.getSettings('UserId');
    let workspaceid = this.localStorageSettings.getSettings('WorkspaceId');
    this.service.retrieveSourceDNSByWorkspaceId(workspaceid).subscribe((res:any)=>{
      if(res == undefined || res == null){
        this.snackbar.open("Source DNS not found. Please configure atleast one dns as source to continue.", "OK", {duration: 5000});
      } else{
        console.log(res);
        this.listOfSourceDNS = res;
        let dnsIds = this.listOfSourceDNS.map(source => source.vaultConfigMstrId);

        console.log(res)
        console.log(dnsIds)

              this.reportCreationData.sourceDNS = dnsIds; 

              this.validations_form.controls['sourceDNS'].setValue(dnsIds);
               this.onSelectionSourceDNS();
              this.selectcheckedfield();
              return;
      }
    })
  }

  onSelectionSourceDNS(){
    this.tablefields = [];
    this.ObjectGrid.api.setGridOption('rowData', []);
    let dnsName = this.reportCreationData.sourceDNS;
    this.spinner.start();
    this.service.retrieveObjectsByMultipleDnsId(dnsName).subscribe((res:any) =>{
      this.spinner.stop();
      console.log(res);
      if (res === null || res.length == 0){
        this.snackbar.open("No Metadata Available for Selected DNS", "OK", {duration: 5000});
      }else{
        this.tablefields = res;
        console.log(this.tablefields);
        this.ObjectGrid.api.setGridOption('rowData', this.tablefields);
        this.onGridReadyForObjects(this.ObjectGrid);
        this.selectcheckedfield();


      }
    })
  }

  // updateFileNameValue(value, id, params) {

  //   for (let i = 0; i < this.selectedObjects.length; i++) {
  //     if (this.selectedObjects[i].id == id) {
  //       this.selectedObjects[i].fileName = value
  //       break;
  //     }
  //   } console.log("selected object from FileNameValue", this.selectedObjects)
  
  //   for (let i = 0; i < this.reportCreationData.objectid.length; i++) {
  //     if (this.reportCreationData.objectid[i].objectid == id) {
  //       this.reportCreationData.objectid[i].fileName = value
  //       break;
  //     }
  //   }
  // }

  updateSetSplitObjectValue(value, id, params) {

    for (let i = 0; i < this.selectedObjects.length; i++) {
      if (this.selectedObjects[i].id == id) {
        this.selectedObjects[i].setSplitObject = value
        break;
      }
    } console.log("selected object from setsplitObject", this.selectedObjects)
  
    for (let i = 0; i < this.reportCreationData.objectid.length; i++) {
      if (this.reportCreationData.objectid[i].objectid == id) {
        this.reportCreationData.objectid[i].setSplitObject = value
        break;
      }
    }
  
  }

  updateGlobalExtractionObjectValue(value, id, params) {

    for (let i = 0; i < this.selectedObjects.length; i++) {
      if (this.selectedObjects[i].id == id) {
        this.selectedObjects[i].globalExtractionObject = value
        break;
      }
    } console.log("selected object from GlobalExtractionObjectValue", this.selectedObjects)
  
    for (let i = 0; i < this.reportCreationData.objectid.length; i++) {
      if (this.reportCreationData.objectid[i].objectid == id) {
        this.reportCreationData.objectid[i].globalExtractionObject = value
        break;
      }
    }
  }

  updateGlobalExtractionObjectFieldValue(value, id, params) {

    for (let i = 0; i < this.selectedObjects.length; i++) {
      if (this.selectedObjects[i].id == id) {
        this.selectedObjects[i].globalExtractionObjectField = value
        break;
      }
    } console.log("selected object from GlobalExtractionObjectFieldValue", this.selectedObjects)
  
    for (let i = 0; i < this.reportCreationData.objectid.length; i++) {
      if (this.reportCreationData.objectid[i].objectid == id) {
        this.reportCreationData.objectid[i].globalExtractionObjectField = value
        break;
      }
    }
  }

  updateExtractionObjectValue(value, id, params) {

    for (let i = 0; i < this.selectedObjects.length; i++) {
      if (this.selectedObjects[i].id == id) {
        this.selectedObjects[i].extractionObject = value
        break;
      }
    } console.log("selected object from ExtractionObjectValue", this.selectedObjects)
  
    for (let i = 0; i < this.reportCreationData.objectid.length; i++) {
      if (this.reportCreationData.objectid[i].objectid == id) {
        this.reportCreationData.objectid[i].extractionObject = value
        break;
      }
    }
  }

  updateExtractionObjectFieldValue(value, id, params) {

    for (let i = 0; i < this.selectedObjects.length; i++) {
      if (this.selectedObjects[i].id == id) {
        this.selectedObjects[i].extractionObjectField = value
        break;
      }
    } console.log("selected object from ExtractionObjectFieldValue", this.selectedObjects)
  
    for (let i = 0; i < this.reportCreationData.objectid.length; i++) {
      if (this.reportCreationData.objectid[i].objectid == id) {
        this.reportCreationData.objectid[i].extractionObjectField = value
        break;
      }
    }
  }
  updateParentObjectFilename(value, id, params) { // parentobjectkeycolumn
   
  for (let i = 0; i < this.selectedObjects.length; i++) {
    if (this.selectedObjects[i].id == id) {
      this.selectedObjects[i].parentobjectfilename = value
      break;
    }
  } console.log("selected object from ParentObjectFilename", this.selectedObjects)

  for (let i = 0; i < this.reportCreationData.objectid.length; i++) {
    if (this.reportCreationData.objectid[i].objectid == id) {
      this.reportCreationData.objectid[i].parentobjectfilename = value
      break;
    }
  }
}
updateparentobjectkeycolumn(value, id, params) { // parentobjectkeycolumn
   
  for (let i = 0; i < this.selectedObjects.length; i++) {
    if (this.selectedObjects[i].id == id) {
      this.selectedObjects[i].parentobjectkeycolumn = value
      break;
    }
  } console.log("selected object from FileNameValue", this.selectedObjects)

  for (let i = 0; i < this.reportCreationData.objectid.length; i++) {
    if (this.reportCreationData.objectid[i].objectid == id) {
      this.reportCreationData.objectid[i].parentobjectkeycolumn = value
      break;
    }
  }
}
updateFileNameValue(value, id, params) {
  
  for (let i = 0; i < this.selectedObjects.length; i++) {
    if (this.selectedObjects[i].id == id) {
      this.selectedObjects[i].filename = value
      break;
    }
  } console.log("selected object from FileNameValue", this.selectedObjects)

  for (let i = 0; i < this.reportCreationData.objectid.length; i++) {
    if (this.reportCreationData.objectid[i].objectid == id) {
      this.reportCreationData.objectid[i].filename = value
      break;
    }
  }
}
updateLevelValue(value, id, params) {
  
  for (let i = 0; i < this.selectedObjects.length; i++) {
    if (this.selectedObjects[i].id == id) {
      this.selectedObjects[i].level = value
      break;
    }
  } console.log("selected object from FileNameValue", this.selectedObjects)

  for (let i = 0; i < this.reportCreationData.objectid.length; i++) {
    if (this.reportCreationData.objectid[i].objectid == id) {
      this.reportCreationData.objectid[i].level = value
      break;
    }
  }
}
updateObjectnameValue(value, id, params) {
   
  for (let i = 0; i < this.selectedObjects.length; i++) {
    if (this.selectedObjects[i].id == id) {
      this.selectedObjects[i].fileName = value
      break;
    }
  } console.log("selected object from FileNameValue", this.selectedObjects)

  for (let i = 0; i < this.reportCreationData.objectid.length; i++) {
    if (this.reportCreationData.objectid[i].objectid == id) {
      this.reportCreationData.objectid[i].fileName = value
      break; 
    }
  }
}
updateParentObjectkeycolumnValue(value, id, params) {
  
  for (let i = 0; i < this.selectedObjects.length; i++) {
    if (this.selectedObjects[i].id == id) {
      this.selectedObjects[i].parentobjectkeycolumn = value
      break;
    }
  } console.log("selected object from FileNameValue", this.selectedObjects)

  for (let i = 0; i < this.reportCreationData.objectid.length; i++) {
    if (this.reportCreationData.objectid[i].objectid == id) {
      this.reportCreationData.objectid[i].parentobjectkeycolumn = value
      break; 
    }
  }
}
updateRequiredInDatalake(value, id, params) { // parentobjectkeycolumn
  
  for (let i = 0; i < this.selectedObjects.length; i++) {
    if (this.selectedObjects[i].id == id) {
      this.selectedObjects[i].requiredInDataLake = value
      break;
    }
  } console.log("selected object from requiredInDataLake", this.selectedObjects)

  for (let i = 0; i < this.reportCreationData.objectid.length; i++) {
    if (this.reportCreationData.objectid[i].objectid == id) {
      this.reportCreationData.objectid[i].requiredInDataLake = value
      break;
    }
  }
}
updaterefreshInIncremental(value, id, params) { // parentobjectkeycolumn
  
  for (let i = 0; i < this.selectedObjects.length; i++) {
    if (this.selectedObjects[i].id == id) {
      this.selectedObjects[i].refreshInIncremental = value
      break;
    }
  } console.log("selected object from refreshInIncremental", this.selectedObjects)

  for (let i = 0; i < this.reportCreationData.objectid.length; i++) {
    if (this.reportCreationData.objectid[i].objectid == id) {
      this.reportCreationData.objectid[i].refreshInIncremental   = value
      break;
    }
  }
}

}
